import React from "react";
import { Link } from "react-router-dom";
import "./css/HubWebsite.css";

const HUB_ITEMS = [
  {
    title: "Blog",
    link: "/blog",
    icon: "◈",
    desc: "Thoughts & Articles",
    color: "#00ffff",
    tag: "READ",
  },
  {
    title: "Portfolio",
    link: "/portifolio",
    icon: "◉",
    desc: "Professional Profile",
    color: "#ff00ff",
    tag: "VIEW",
  },
  {
    title: "Services",
    link: "/services",
    icon: "⚡",
    desc: "What I Can Build For You",
    color: "#ffcc00",
    tag: "HIRE",
  },
  {
    title: "About / Contact",
    link: "/about-me",
    icon: "◎",
    desc: "Get In Touch",
    color: "#00ff88",
    tag: "CONNECT",
  },
  {
    title: "GitHub",
    link: "https://github.com/Felippefn",
    icon: "⬡",
    desc: "Source Code & Repos",
    color: "#ff6b6b",
    tag: "CODE",
    external: true,
  },
  {
    title: "LinkedIn",
    link: "https://www.linkedin.com/in/felippefn/",
    icon: "▣",
    desc: "Professional Network",
    color: "#4da6ff",
    tag: "NETWORK",
    external: true,
  },
  {
    title: "Game Dev",
    link: "/gaming-portfolio",
    icon: "▶",
    desc: "Games I've Created",
    color: "#ff00aa",
    tag: "PLAY",
  },
  {
    title: "Projects",
    link: "/projects",
    icon: "◆",
    desc: "All My Work",
    color: "#00ccff",
    tag: "EXPLORE",
  },
  {
    title: "Design & Art",
    link: "#",
    icon: "◈",
    desc: "Creative Work",
    color: "#888",
    tag: "SOON",
    disabled: true,
  },
  {
    title: "Go2Freelas",
    link: "#",
    icon: "⬢",
    desc: "Freelance Platform",
    color: "#888",
    tag: "SOON",
    disabled: true,
  },
];

const HubWebsite = () => {
  return (
    <div className="hub-page">
      <div className="hub-scanlines" aria-hidden="true" />
      <div className="hub-ambient" aria-hidden="true" />

      <header className="hub-header">
        <Link to="/" className="hub-back">
          ◄ HOME
        </Link>
        <div className="hub-title-group">
          <p className="hub-eyebrow">{'// NAVIGATION_HUB'}</p>
          <h1 className="hub-title">SELECT DESTINATION</h1>
        </div>
        <div className="hub-status">
          <span className="hub-status-dot" />
          ONLINE
        </div>
      </header>

      <main className="hub-grid">
        {HUB_ITEMS.map((item, i) => {
          const inner = (
            <>
              <div className="hub-card-glow" aria-hidden="true" />
              <span className="hub-card-tag">{item.tag}</span>
              <div className="hub-card-icon" aria-hidden="true">{item.icon}</div>
              <h2 className="hub-card-title">{item.title}</h2>
              <p className="hub-card-desc">{item.desc}</p>
              <div className="hub-card-corners" aria-hidden="true">
                <span /><span /><span /><span />
              </div>
              <div className="hub-card-line" aria-hidden="true" />
            </>
          );
          if (item.disabled) {
            return (
              <div
                key={i}
                className="hub-card hub-card--disabled"
                style={{ "--c": item.color }}
                aria-disabled="true"
              >
                {inner}
              </div>
            );
          }
          return (
            <a
              key={i}
              href={item.link}
              className="hub-card"
              target={item.external ? "_blank" : undefined}
              rel={item.external ? "noopener noreferrer" : undefined}
              style={{ "--c": item.color }}
            >
              {inner}
            </a>
          );
        })}
      </main>

      <footer className="hub-footer">
        <span>FN STUDIOS © 2025</span>
      </footer>
    </div>
  );
};

export default HubWebsite;
